import { render, staticRenderFns } from "./WellnessChallengeQuestionsNotification.vue?vue&type=template&id=bf55d626&scoped=true&lang=pug&"
import script from "./WellnessChallengeQuestionsNotification.vue?vue&type=script&lang=js&"
export * from "./WellnessChallengeQuestionsNotification.vue?vue&type=script&lang=js&"
import style0 from "./WellnessChallengeQuestionsNotification.vue?vue&type=style&index=0&id=bf55d626&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf55d626",
  null
  
)

export default component.exports